var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewSummary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-1083 -533)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 18,
    height: 18,
    transform: "translate(1083 534)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "summary",
    transform: "translate(1081.42 531.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(4.822 5.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 8.651,
    height: 1.358,
    rx: 0.679,
    transform: "translate(0.33 0.33)",
    fill: "#656485"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(4.822 8.463)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 8.387,
    height: 1.358,
    rx: 0.679,
    transform: "translate(0.33 0.33)",
    fill: "#656485"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(4.822 11.419)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 5.058,
    height: 1.358,
    rx: 0.679,
    transform: "translate(0.33 0.33)",
    fill: "#656485"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye",
    "data-name": "Icon feather-eye",
    transform: "translate(9.477 14.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    d: "M2,1A1,1,0,0,0,1,2V16a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H13a2,2,0,0,1,2,2V16a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z",
    transform: "translate(-6.897 -12.291)",
    fill: "#656485"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 5,
    cy: 4,
    rx: 5,
    ry: 4,
    transform: "translate(-0.897 -1.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M5.545,7.5A3.145,3.145,0,0,0,3.282,8.942a3.145,3.145,0,0,0,2.263,1.442A3.145,3.145,0,0,0,7.808,8.942,3.145,3.145,0,0,0,5.545,7.5m0-1.5C8.119,6,9.59,8.942,9.59,8.942s-1.471,2.942-4.045,2.942S1.5,8.942,1.5,8.942,2.971,6,5.545,6Z",
    transform: "translate(-1.5 -6)",
    fill: "#656485"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_8",
    "data-name": "Path 8",
    transform: "translate(-10.391 -11.494)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.373,14.436a.936.936,0,1,1-.936-.936A.936.936,0,0,1,15.373,14.436Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.43625831604004 15.37251853942871 C 13.9191780090332 15.37251853942871 13.49999809265137 14.95333862304688 13.49999809265137 14.43625831604004 C 13.49999809265137 13.9191780090332 13.9191780090332 13.49999809265137 14.43625831604004 13.49999809265137 C 14.95333862304688 13.49999809265137 15.37251853942871 13.9191780090332 15.37251853942871 14.43625831604004 C 15.37251853942871 14.95333862304688 14.95333862304688 15.37251853942871 14.43625831604004 15.37251853942871 Z",
    stroke: "none",
    fill: "#656485"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSummary);
export default __webpack_public_path__ + "static/media/view_summary.d4c34be9f224e27a24d9594b13faf431.svg";
export { ForwardRef as ReactComponent };